<template lang="pug">
div
  section.fullBg(:class="{'d-none': showPrize == true}")
    template
      .step1
        .title
          img(src='/images/lucky-spin/logo.png')
        .centerBlocks
          button.score(v-if="isLoggedIn") SPINS LEFT: {{tokenBalance}}
          div(:class="isDefault ? 'first' : 'second d-block'")
            img.spinBlock(:src="isDefault ? '/images/lucky-spin/centerBlock.png' : `/images/lucky-spin/${prizeWon}.png`")
            span.pointer(
              :class="isDefault ? 'clickSpin' : 'clickPrice'" 
              @click="isDefault ? spinEgg() : triggerPop()"
            )
          .position-absolute.bottom-0
            img(src="/images/lucky-spin/t&c.png")
          //- .first(:class="{'d-none': isDefault == false}")
          //-   img.spinBlock(src='/images/lucky-spin/centerBlock.png')
          //-   span.clickSpin.pointer(@click="spinEgg")
          //- .second(:class="{'d-block': isDefault == false}")
            img.spinBlock(:src="`/images/lucky-spin/${prizeWon}.png`")
            span.clickPrice(@click="triggerPop") 
    //- template(v-else)
      .text-white.my-2.text-center
        i.fas.fa-duotone.fa-spinner.fa-spin-pulse
    .container
      .content-padding
        template(v-if="getLanguage=='my'")
          h4 TERMA DAN SYARAT
          h4 Token berdasarkan Jumlah Deposit Harian:
          ul
            li Deposit RM50 – RM100: Dapat 1 token
            li Deposit RM101 – RM250: Dapat 2 token
            li Deposit RM251 – RM499: Dapat 5 token
            li Deposit RM500 dan ke atas: Dapat 7 token
          ul
            li Ganjaran: RM5, RM8, RM18, RM38, RM58, RM388, RM588, RM1288
            li Maksimum 7 token boleh diperoleh setiap hari
            li Maksimum 10 token boleh disimpan
            li Keperluan X3 turnover sebelum pengeluaran
            li Pengeluaran maksimum: RM1288
            li Boleh main EpicWin, MegaH5, JILI, SpadeGaming, Habanero, Fachai dan Advantplay games 
              a.text-warning.text-decoration-underline(href="https://epicwin8.net/articles/epic-lucky-spin-ban-game-list/" target="_blank") sahaja
            li Baki mesti kurang daripada RM5 sebelum menebus promosi
            li Jika tidak, deposit akan mengikut Terma & Syarat Epic Lucky Spin
          h3 Terma & Syarat Umum
          ul
            li Pengeluaran dihadkan kepada 5 kali sehari
            li EpicWin berhak sepenuhnya untuk menamatkan akaun ahli sekiranya berlaku pelanggaran T&C tanpa notis awal
            li Jumlah pengeluaran minimum adalah RM10
        template(v-if="getLanguage=='en'")
          h4 TERMS AND CONDITIONS
          h4 Token are based on Daily Accumulated Deposit:
          ul
            li Deposit RM50 – RM100: Get 1 token
            li Deposit RM101 – RM250: Get 2 tokens
            li Deposit RM251 – RM499: Get 5 tokens
            li Deposit RM500 and above: Get 7 tokens
          ul
            li Rewards: RM5, RM8, RM18, RM38, RM58, RM388, RM588, RM1288
            li Maximum 7 tokens can be earned per day
            li Maximum 10 tokens can be stored
            li X3 turnover required before withdrawal
            li Max withdrawal: RM1288
            li Can play EpicWin, MegaH5, JILI, SpadeGaming, Habanero, Fachai and Advantplay games 
              a.text-warning.text-decoration-underline(href="https://epicwin8.net/articles/epic-lucky-spin-ban-game-list/" target="_blank") only
            li Balance must be below RM5 before claiming
            li Otherwise, deposit will follow Epic Lucky Spin T&C
          h3 General Terms and Conditions
          ul
            li Withdrawal is limited to 5 times per day.
            li EpicWin reserves all rights to terminate members' accounts in case of T&C violations without prior notice
            li Minimum withdrawal amount is RM10
        template(v-if="getLanguage=='zh'")
          h4 条款与条件
          h4 代币根据每日累计存款发放：
          ul
            li 存款 RM50 – RM100：获得 1 个代币
            li 存款 RM101 – RM250：获得 2 个代币
            li 存款 RM251 – RM499：获得 5 个代币
            li 存款 RM500 以上：获得 7 个代币
          ul
            li 奖励金额：RM5、RM8、RM18、RM38、RM58、RM388、RM588、RM1288
            li 每日最多可获得 7 个代币
            li 最多可储存 10 个代币
            li 提款需完成 X3 流水要求
            li 提款金额上限为 RM1288
            li 
              a.text-warning.text-decoration-underline(href="https://epicwin8.net/articles/epic-lucky-spin-ban-game-list/" target="_blank") 仅限
              | 于 EpicWin, MegaH5, JILI, SpadeGaming, Habanero, Fachai 和 Advantplay 的游戏
            li 申领奖励前余额必须低于 RM5
            li 否则，存款将遵循 Epic Lucky Spin 条款与条件
          h3 一般条款与条件
          ul
            li 每日最多提款 5 次
            li 若违反条款与条件，EpicWin 有权在无事先通知的情况下终止会员账户
            li 最低提款金额为 RM10
  .showGift(:class="{'d-block': showPrize == true}")
    img(:src="`/images/lucky-spin/popup${prizeWon}.jpg`" @click="goTo")
    //- img(:src="`/images/lucky-spin/popup.jpg`" @click="goTo")
    .button-center.text-center
      button.login-btn.rounded-pill(@click.stop="closePop")
        i.fa-solid.fa-sync
        | Spin Again
</template>
<script>
export default{
	data(){
		return{
      isDefault: true,
      startRender: false,
			goDepo:true,
      tokenBalance: null,
      showPrize:false,
      prizeWon: null
		}
	},
	computed: {
    isLoggedIn(){
      return this.$store.getters.isLoggedIn
    },
    accountID() {
      return this.$store.getters.accountID
    },
    sessionToken() {
      return this.$store.getters.sessionToken
    },
    getLanguage() {
      return this.$store.getters.language || "en"
    },
  },
	watch:{
    sessionToken(newState, oldState){
      if(newState === '' || newState === undefined){
        this.isDefault = true
        this.showPop = false
      }else{
        this.getSpinToken()
      }
    }
  },
  mounted() {
    // this.addStylesheet();
    window.scroll(0,0)
    document.body.classList.add("custom-font");
    this.getSpinToken()
  },
  beforeDestroy() {
    // this.removeStylesheet();
    document.body.classList.remove("custom-font");
  },
	methods:{
    triggerPop(){
      this.showPrize = true
    },
    closePop(){
      this.isDefault = true
      this.showPrize = false
      this.prizeWon = null
      if(window.innerWidth > 768){
        window.scroll({
          top: 500,
          left: 0,
          behavior: 'smooth'
        })
      }
      
    },
    goTo(){
      this.$router.push("/inbox").catch(error =>{})
    },
    togglePop(){
      this.showPop = !this.showPop
    },
    claimAct(){
      this.togglePop()
    },
    getSpinToken(){
      if (this.sessionToken) {
        this.startRender = true
        let account_id = this.accountID
        let auth_token = this.sessionToken
        this.$store
          .dispatch("user/getSpinToken", { account_id, auth_token })
          .then(response => {
            if (response.success == true) {
              if(response.data.length > 0){
                this.tokenBalance = response.data[0].token
              }
              
            } else {
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }              
            }
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }  
          });
      }
    },
    spinEgg(){
      if (this.sessionToken) {
        this.isDefault = false
        let account_id = this.accountID
        let auth_token = this.sessionToken
        this.$store
          .dispatch("user/spinEgg", { account_id, auth_token })
          .then(response => {
            if (response.success == true) {
              if(response.data.length > 0){
                this.prizeWon = response.data[0].prize_amount
                if(window.innerWidth > 768){
                  window.scroll({
                    top: 500,
                    left: 0,
                    behavior: 'smooth'
                  })
                }
                this.getSpinToken()
              }
              
            } else {
              this.isDefault = true
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }              
            }
          })
          .catch(response => {
            this.isDefault = true
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }  
          });
      }else{
        this.$router.push("/login").catch(err => {});
      }
    },
    depoAct(){
      if(this.isLoggedIn){
				this.$router.push("/deposit").catch(err => {});
			}else{
				this.$router.push("/login").catch(err => {});
			}
    }
	}
}
</script>
<style lang="css" scoped>
* {
    box-sizing: border-box;
}

.fullBg {
    background-image: url('/images/lucky-spin/bg.jpg');
    background-repeat: no-repeat;
    background-position: center top;
    background-size: 100% auto;

    background-color: #300449;
    position: relative;
    max-width: 800px;
    margin: auto;
    padding-top: 90px;
}

.showGift {
    position: relative;
    max-width: 800px;
    margin: auto;
    display: none;
}
.showGift img{
    width: 100%;
    height: auto;
    cursor: pointer;
}

.title,
.gift,
.lockImg {
    text-align: center;
}



.title img {
    max-width: 90%;
    margin: auto;
}

.title {
    cursor: pointer;
}

.container {
    position: relative;
    padding: 0 10px;
    margin: 0 auto;
    max-width: 1360px;
}

.content-padding {
    padding-top: 50px;
    padding-bottom: 50px;
    color: #fff;
}




.centerBlocks {

    position: relative;
}

.centerBlocks img {
    max-width: 100%;
    padding-top: 10px;
    padding-bottom: 30px;
    margin: auto;
    display: block;
}

button.score {
    background: #1794F4;
    background: linear-gradient(0deg, rgba(23, 148, 244, 1) 0%, rgba(46, 192, 254, 1) 100%);
    color: #fff;
    font-size: 20px;
    font-weight: 800;
    padding: 15px 25px;
    border-radius: 40px;
    text-shadow: 0 0 10px #31066b,
        0 0 20px #31066b,
        0 0 30px #31066b;
    -webkit-text-stroke: 1px navy;
    margin-left: 20px;
}

.clickSpin {
  width: 200px;
  height: 200px;
  display: block;
  position: absolute;
  bottom: 70px;
  right: 50px;
  cursor: pointer;
}

.clickPrice {
  width: 200px;
  height: 200px;
  display: block;
  position: absolute;
  bottom: 80px;
  left: 60px;
  cursor: pointer;
}

@media(min-width: 576px) and (max-width: 768px){
  .clickSpin {
    width: 230px;
    height: 230px;
    display: block;
    position: absolute;
    bottom: 70px;
    right: 100px;
    cursor: pointer;
  }

  .clickPrice {
    width: 200px;
    height: 200px;
    display: block;
    position: absolute;
    bottom: 120px;
    left: 90px;
    cursor: pointer;
  }
}

@media(min-width: 768px){
  .clickSpin {
    width: 200px;
    height: 200px;
    display: block;
    position: absolute;
    bottom: 110px;
    right: 130px;
    cursor: pointer;
  }

  .clickPrice {
    width: 200px;
    height: 200px;
    display: block;
    position: absolute;
    bottom: 145px;
    left: 145px;
    cursor: pointer;
  }
}

.second {
    display: none;
}

.button-center{
  position: absolute;
  bottom: 8%;
  width: 100%;
  /* margin: 0 auto; */
  
}

.login-btn{
  border: 3px solid yellow;
  font-size: 30px;
  width: 35%;
  height: 75px;
  margin: 0;
}
@media(max-width: 720px){
  .login-btn{
    font-size: 16px;
    height: 43px;
  }
}
</style>